<div class="container">
  <h2>My Likes</h2>

  <!-- FILTERS + SORT ROW -->
  <div class="controls-row">
    <div class="filter-pills">
      <button mat-button (click)="setFilter('all')" [class.active]="(filter$ | async) === 'all'">All</button>
      <button mat-button (click)="setFilter('model')" [class.active]="(filter$ | async) === 'model'">Models</button>
      <button mat-button (click)="setFilter('image')" [class.active]="(filter$ | async) === 'image'">Images</button>
      <button mat-button (click)="setFilter('video')" [class.active]="(filter$ | async) === 'video'">Videos</button>
    </div>

    <button mat-stroked-button color="primary" class="sort-btn" (click)="toggleSortOrder()">
      Sort: {{ (sortOrder$ | async) === 'asc' ? 'Oldest → Newest' : 'Newest → Oldest' }}
    </button>
  </div>

  <!-- LIKED ITEMS GRID -->
  <div class="liked-grid" *ngIf="(filteredAndSortedItems$ | async) as items">
    <ng-container *ngIf="items.length > 0; else noLikes">

      <div *ngFor="let item of items" class="liked-card">

        <!-- MODEL CARD -->
        <mat-card *ngIf="item.type === 'model'"
                  class="card model-card"
                  appearance="outlined"
                  [routerLink]="['/models', item.data?.model_id]"
                  tabindex="0">

          <img mat-card-image
               class="card-media"
               [src]="item.data?.profile_image_url ? item.data?.profile_image_url :
                     (item.data?.gender === 'Male'
                       ? 'assets/images/placeholder_male_profile_image.png'
                       : 'assets/images/placeholder_profile_image.png')" />

          <div class="card-body">
            <div class="title">{{ item.data?.name }}</div>
            <div class="subtitle">{{ item.data?.age }}</div>

            <p class="description">
              {{ item.data?.description }}
            </p>
          </div>

          <div class="card-footer">
            <mat-icon color="warn">favorite</mat-icon>
            <span>{{ item.likedAt | date:'shortDate' }}</span>
          </div>
        </mat-card>

        <!-- IMAGE CARD -->
        <mat-card *ngIf="item.type === 'image'" class="card media-card" appearance="outlined">
          <img mat-card-image class="card-media" [src]="item.data?.firebaseUrl" />

          <div class="card-footer">
            <mat-icon color="warn">favorite</mat-icon>
            <span>{{ item.likedAt | date:'shortDate' }}</span>
          </div>
        </mat-card>

        <!-- VIDEO CARD -->
        <mat-card *ngIf="item.type === 'video'" class="card media-card" appearance="outlined">
          <video class="card-media" [src]="item.data?.firebaseUrl" controls playsinline></video>

          <div class="card-footer">
            <mat-icon color="warn">favorite</mat-icon>
            <span>{{ item.likedAt | date:'shortDate' }}</span>
          </div>
        </mat-card>

      </div>
    </ng-container>

    <ng-template #noLikes>
      <div class="no-content-message">You have not liked any content yet.</div>
    </ng-template>
  </div>
</div>
